// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"2451":"b685ef","4283":"49d1cc","4612":"c2a789","6749":"6f53ec","7000":"2f70e4"}[chunkId] + ".css";
};